export default __webpack_public_path__ + "static/media/grey-border.697b241c.svg";